export default __webpack_public_path__ + "static/media/usados.89036d00.svg";